export const mockData = {
  hero: {
    name: "Christiane YAO",
    title: "Cuisinière Vegan – Ambassadrice du Garba-Bio",
    subtitle: "Créatrice de saveurs authentiques et durables",
    profileImage: "/images/samini-profil.png"
  },
  about: {
    bio: "Passionnée par la cuisine traditionnelle ivoirienne depuis mon enfance, j'ai découvert ma vocation dans la transformation créative des plats ancestraux en versions saines et végétaliennes. Mon parcours m'a menée de la cuisine familiale aux grandes tables, toujours guidée par le respect des saveurs authentiques et la valorisation des produits locaux.",
    formation: "Diplômée en Arts Culinaires de l'Institut de Cuisine d'Abidjan, spécialisée en nutrition végétale",
    inspirations: "Mes grands-mères qui m'ont transmis l'amour des épices, la permaculture, et la conviction que bien se nourrir est un acte d'amour envers soi et la planète."
  },
  experience: {
    achievements: [
      {
        title: "Chef Exécutive - Restaurant Le Jardin Vert",
        period: "2020-2023",
        description: "Direction culinaire complète d'un restaurant éco-responsable de 80 couverts, création de menus saisonniers 100% végétaux inspirés de la tradition ivoirienne."
      },
      {
        title: "Participation au Festival International de Cuisine Végétale",
        period: "2022",
        description: "Première place dans la catégorie 'Innovation Traditionnelle' avec ma création du Garba-Bio, reconnue par un jury international."
      },
      {
        title: "Consultante Nutrition Végétale",
        period: "2019-2020",
        description: "Accompagnement de restaurants et particuliers vers une transition alimentaire végétale équilibrée, formation de 150+ personnes."
      },
      {
        title: "Formation Continue - Université de Gastronomie Durable",
        period: "2021",
        description: "Certification en cuisine durable et agriculture biologique, approfondissement des techniques de fermentation africaines."
      }
    ]
  },
  garbaBio: {
    title: "Garba-Bio : Ma Création Signature",
    description: "Le Garba-Bio révolutionne l'attiéké traditionnel en version 100% biologique et végétale. Cette création unique préserve l'authenticité du goût tout en apportant une valeur nutritionnelle exceptionnelle grâce à des légumes biologiques locaux, des protéines végétales innovantes et des épices soigneusement sélectionnées.",
    features: [
      "Attiéké bio produit par des coopératives locales",
      "Légumes frais issus de l'agriculture durable", 
      "Sauces créatives aux épices traditionionnelles revisitées",
      "Zéro déchet, emballages compostables"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_vegan-chef-cv/artifacts/clmttlyw_cuisine-2.jpg",
      "https://customer-assets.emergentagent.com/job_vegan-chef-cv/artifacts/f5udicp8_festival-2.jpg",
      "https://customer-assets.emergentagent.com/job_vegan-chef-cv/artifacts/ju6gk1fz_festival-plat-3.jpg"
    ]
  },
  contact: {
    email: "yao.christian.chef@email.com",
    phone: "+225 07 XX XX XX XX",
    location: "Abidjan, Côte d'Ivoire",
    social: {
      instagram: "@yaochristian_chef",
      facebook: "Christiane YAO - Chef Vegan",
      linkedin: "yao-christian-chef"
    }
  }
};